// "Voltar ao link depois do login" (PO1-3391, decisão P3 do kickoff). O link do
// e-mail do pedido de análise aponta para o Extrato do MeuFrete; quem não está
// logado cai no /auth/login?next=<destino> e, depois de entrar (ou de aceitar o
// convite), volta para o destino. Só caminhos internos do app (/app/...): nada
// de URL externa, protocolo, barra dupla ou barra invertida (open redirect).
export function nextSeguro(valor) {
  const v = String(valor == null ? "" : valor).trim();
  if (!v.startsWith("/app/")) return null;
  if (v.startsWith("//") || /[\\]/.test(v) || /:\/\//.test(v) || /[\r\n]/.test(v)) return null;
  return v;
}

// Lê o `next` de um `location.search` ("?next=...") já validado.
export function lerNext(search) {
  try {
    const params = new URLSearchParams(String(search || ""));
    return nextSeguro(params.get("next"));
  } catch (_) {
    return null;
  }
}

// Monta `path?next=<destino>` só quando o destino é seguro; senão devolve `path`.
export function comNext(path, destino) {
  const n = nextSeguro(destino);
  return n ? `${path}?next=${encodeURIComponent(n)}` : path;
}

// Destino atual (pathname + search) de um `location` do router ou do window.
export function destinoDe(location) {
  if (!location) return null;
  return `${location.pathname || ""}${location.search || ""}`;
}
